import { useEffect } from 'react'
import { useHistory, useParams } from 'react-router'
import { SendPrescripitonDocUI } from './sendPrescriptionDocUI'
import { useSendDocuments } from '../../hooks/useSendDocuments/useSendDocuments'

function SendPrescripitonDoc() {
  const props = useSendDocuments()

  const history = useHistory()
  const { order_id } = useParams<{ order_id?: string }>()

  useEffect(() => {
    try {
      window.history.pushState(null, '', window.location.href)
    } catch {
      /* noop */
    }

    const handlePop = () => {
      const isLeavingRoute = !window.location.pathname.startsWith('/enviar-receita')
      if (isLeavingRoute) {
        const current = `/enviar-receita/${order_id || ''}`.replace(/\/$/, '')
        history.replace(current)
        return
      }
      try {
        window.history.go(1)
      } catch {
        /* noop */
      }
    }

    window.addEventListener('popstate', handlePop)
    const unlisten = history.listen((loc, action) => {
      if (action === 'POP' && !loc.pathname.startsWith('/enviar-receita')) {
        const current = `/enviar-receita/${order_id || ''}`.replace(/\/$/, '')
        history.replace(current)
      }
    })

    return () => {
      window.removeEventListener('popstate', handlePop)
      unlisten()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history, order_id])

  return <SendPrescripitonDocUI {...props} />
}

export default SendPrescripitonDoc
